/**
 * 任务
 */
import welfareApi from '../../api/welfare.api'

const state = {
    taskList: {},
    gloablMsg:true
};

const getters = {
};

const mutations = {
    setTaskList(state, data) {
        state.taskList = data;
    },
    setGloablMsg(state, data) {
        if(data==='已完善资料'){
            state.gloablMsg = true;
        }else{
            state.gloablMsg = false;
        }
    }

};

const actions = {
    //获取任务列表
    getTaskList({commit}) {
        return welfareApi.getOneWelfare().then(list => {
            commit('setTaskList', list);
            return list;
        })
    },
    //获取任务项信息
    getTaskItem({state, dispatch}, key) {
        return state.taskList.length ?
            Promise.resolve(state.taskList) :
            dispatch('getTaskList').then(() => {
                return state.taskList
            });

    },
    //验证任务是否已经完成过
    isFinishTask({}, params) {
        return welfareApi.isFinishTask(params);
    },
    //验证任务条件是否达到
    canFinishTask({}, taskId) {
        return welfareApi.canFinishTask(taskId);
    },
    //完成任务
    finishTask({}, taskId) {
        return welfareApi.finishTask(taskId);
    },
    welfareList({}, params) {
        return welfareApi.welfareList(params);
    },
    getTypeWelfare({}, params) {
        return welfareApi.getTypeWelfare(params);
    },
    getShareList({}, params) {
        return welfareApi.getShareList(params);
    },
    getLogList({}, params) {
        return welfareApi.getLogList(params);
    },
    updateLog({}, params) {
        return welfareApi.updateLog(params);
    },
    getWordLog({}, params) {
        return welfareApi.getWordLog(params);
    },
    addLog({}, params) {
        return welfareApi.addLog(params);
    },
    addShareLog({}, params) {
        return welfareApi.addShareLog(params);
    },
    //是否判断完善资料
    getTypeLog({commit}) {
        return welfareApi.getTypeLog().then(list => {
            commit('setGloablMsg', list);
            return list;
        })
    },

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./app/store/modules/welfare.js